<template>
    <div
        v-if="jackpot"
        class="bng-jackpot"
        :class="[`jackpot-${jackpot.skin}`, { 'jackpot-glow': jackpotReadyToPlay }]"
    >
        <div class="jackpot-inner">
            <div class="jackpot-label">
                <div v-if="jackpot.shared" class="jackpot-type">{{"components.common.jackpots.jackpot.shared" | translate}}</div>
                <div v-else class="jackpot-type">{{"components.common.jackpots.jackpot.single" | translate}}</div>
            </div>
            <div class="jackpot-label">
                <div class="jackpot-name">{{jackpot.name}}</div>
                <div class="jackpot-value">{{jackpot.amount | currency(player.balance.currency)}}</div>
            </div>
            <div class="jackpot-progress">
                <div
                    class="jackpot-bar"
                    v-if="jackpot.percent"
                    v-bind:style="{width: jackpot.percent + '%'}"
                ></div>
            </div>
            <div class="jackpot-label">
                <div class="jackpot-min-stake">Play {{jackpot.stakeMin | currency(jackpot.currency)}} up</div>
                <div v-if="jackpot.shared" class="jackpot-shared-remain">
                    <span v-if="remain">{{remain}}s</span>
                    <span class="jackpot-shared-lamp" :class="{'jackpot-shared-lamp-on': remain, 'jackpot-shared-lamp-off': !remain}">⬤</span>
                </div>
            </div>
            <div class="jackpot-blick"></div>
        </div>
    </div>
</template>
<script>
import Vue from 'vue';
import { mapGetters } from 'vuex';

export default {
    name: 'jackpot',
    props: {
        jackpot: {
            type: Object,
            required: true
        },
        remain: 0,
        remainTimer: null
    },
    computed: {
        player() {
            return Vue.state.player.get();
        },
        jackpotReadyToPlay() {
            return this.jackpot.percent >= 100;
        },
        jackpotSharedRemain() {
            return parseInt(this.jackpot.sharedRemain || 0);
        }
    },
    watch: {
        jackpotSharedRemain(v) {
            this.remain = v;
        }
    },
    created() {
        this.remainTimer = setInterval(() => {
            if (this.remain) this.remain--;
        }, 1000);
    },
    beforeDestroy() {
        clearInterval(this.remainTimer);
    }
};
</script>
<style lang="scss">
</style>



// WEBPACK FOOTER //
// front/src/skins/bulmasite/components/common/jackpots/jackpot/jackpot.vue